import React, { ChangeEvent, useState } from 'react';
import { InputText } from '@increasecard/typed-components';
import { useTranslation } from 'react-i18next';

interface ResponsibleProps {
  onResponsibleChanged: (field: string, value: string) => void;
  value?: string;
}

const Responsible = ({ onResponsibleChanged, value }: ResponsibleProps) => {
  const [responsible, setResponsible] = useState<string>(value || '');
  const { t } = useTranslation();
  const onResponsibleChange = (event: ChangeEvent<HTMLInputElement>) =>
    setResponsible(event.currentTarget.value);
  const onResponsibleBlur = (event: ChangeEvent<HTMLInputElement>) =>
    onResponsibleChanged('responsible', event.currentTarget.value);
  return (
    <InputText
      inline
      name="responsible"
      onBlur={onResponsibleBlur}
      onChange={onResponsibleChange}
      placeholder={t('chargebacks:List:fields:responsible:placeholder')}
      value={responsible}
    />
  );
};

export default Responsible;
